import { render, staticRenderFns } from "./title2.vue?vue&type=template&id=2b348e0d&scoped=true"
import script from "./title2.vue?vue&type=script&lang=js"
export * from "./title2.vue?vue&type=script&lang=js"
import style0 from "./title2.vue?vue&type=style&index=0&id=2b348e0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b348e0d",
  null
  
)

export default component.exports